import React from "react";
import { Row, Col, Avatar } from "antd";
import { g4 } from "../../../../utils/helper";
import { CommentOutlined } from "@ant-design/icons";
import { replaceUrlWithAnchor } from "@Lib/common";

class Item extends React.Component {
  io = null;
  constructor(props) {
    super(props);
    this.state = {
      value: "",
    };
    this.value = "";
  }
  respond(re_id, item) {
    //點擊回應
    let value = this.refs[`textarea-${re_id}`].value;
    this.props.replyComment(re_id, value, item);
    this.refs[`textarea-${re_id}`].value = ""
  }
  componentWillReceiveProps(res) {
    if (this.value != "") {
      let _ref = this.refs[this.value];
      _ref.style.display = "none";
      this.value = "";
    }
  }
  componentDidMount() {
    this.scrollWatch(this.el);
  }
  showReplyComment(id) {
    let _ref = "";
    if (this.value != "") {
      _ref = this.refs[this.value];
      _ref.style.display = "none";
      this.value = "";
    } else {
      this.value = `foot-${id}`;
      _ref = this.refs[this.value];
      _ref.style.display = "block";
    }
  }

  scrollWatch = (el) => {
    let isFrist = false;

    try {
      this.io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !isFrist) {
            isFrist = true;
            g4 &&
              g4("element_exposured", {
                page_name: "影音詳情頁",
                element: "列表",
                element_id: "留言列表",
              });
          }
        },
        { threshold: [0.65] },
      );
      if (el) {
        this.io.observe(el);
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { data, type } = this.props;

    return (
      <div className="pl-14 border-0 border-b-1 border-[#F1F1F1] border-solid mb-12" ref={(el) => (this.el = el)}>
        <Row>
          <Col span={2}>
            <Avatar
              size={52}
              src={
                (data?.hasOwnProperty("member") ? data?.member.m_headpic_new : data?.user?.cover) ||
                "https://photo.8891.com.tw/2022/10/11/1665473463771127.png"
              }
            />
          </Col>
          <Col span={22}>
            <h4 className="flex items-center justify-start text-18">
              {data?.m_name || data?.user?.name}{" "}
              <span className="text-[#999] text-12 ml-10">{data?.add_time || data?.comment.date}</span>
            </h4>
            <div
              className="w-[90%] h-auto leading-20 text-14 text-[#666] mt-20 word-wrap"
              style={{ marginBottom: type !== "ytb" ? "" : "30px" }}
              dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(data?.content || data?.comment?.content) }}
            ></div>
            <div className="text-right">
              {type !== "ytb" && (
                <div
                  className="text-14 cursor-pointer inline-block my-6"
                  style={{ color: "#33333380" }}
                  onClick={() => this.showReplyComment(data?.id || data?.comment?.id)}
                >
                  <CommentOutlined style={{ fontSize: "16px" }} className='mr-6' />
                  回應
                </div>
              )}
              <div
                className="relative mb-10 hidden"
                ref={`foot-${data?.id || data?.comment.id}`}
              >
                <textarea
                  ref={`textarea-${data?.id || data?.comment?.id}`}
                  className="py-6 px-10 border-none overflow-hidden bg-[#F5F5F5] mb-10 rounded-8 w-full h-[78px] leading-[26px] text-16 text-[#000] resize-none"
                  placeholder={`回覆${data?.m_name || data?.user?.name}:`}
                />
                <div
                  className="w-96 h-40 text-16 text-[#fff] flex items-center justify-center rounded-8 cursor-pointer ml-auto"
                  style={{ backgroundColor: "#0a88ec" }}
                  onClick={() => {
                    this.respond(data?.id || data?.comment?.id, data)
                  }}
                >
                  回應評論
                </div>
              </div>
            </div>
            {data?.hasOwnProperty("comment") && JSON.stringify(data?.comment?.reply) !== "{}" && (
              <div className="mb-12 bg-[#F5F5F5] rounded-8 w-full">
                <div className="p-20 text-14">
                  <h5 className="text-16">
                    {data?.comment?.reply?.user?.name}
                  </h5>
                  <div
                    className="mt-6 text-14"
                    dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(data?.comment?.reply?.comment?.content ?? "") }}
                  ></div>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default Item;
